// Starter kernel shown in the custom-kernel editor. A clean, verifiable example: estimate
// the area under a quarter-circle by sampling (arithmetic + rng only → cross-engine
// bitwise). Authors edit from here. It must pass the determinism linter as-is.
export const CUSTOM_KERNEL_TEMPLATE = `// Custom kernel — a self-contained ES module.
// Randomness comes ONLY from \`rng\`; transcendentals ONLY from the \`math\` shim.
// (no Math.random / Date / performance / crypto / Math.log…; the linter enforces this.)

export default {
  id: "my-kernel",
  label: "My custom kernel",
  verifiable: true,        // true is honoured only if you avoid math.* transcendentals
  resultUnit: "estimate",
  chunkSize: 50000,        // iterations per chunk; chunk count = ceil(N / chunkSize)

  // Optional: tunable inputs. The playground renders a control per param, and the chosen
  // values are part of the run's identity (same seed + N + params ⇒ identical bits) and are
  // saved in the permalink. The 4th chunk() argument is { key: value } for these.
  params: [
    { key: "radius", label: "Radius", default: 1, min: 0.1, max: 5, step: 0.1,
      hint: "Radius of the circle being sampled in the unit square." },
  ],

  // Run \`count\` iterations with the seeded rng; return a partial (any JSON-able object).
  chunk(count, rng, math, params) {
    const r2 = params.radius * params.radius;
    let hits = 0;
    for (let i = 0; i < count; i++) {
      const x = rng.float();
      const y = rng.float();
      if (x * x + y * y < r2) hits++;   // inside the circle of this radius?
    }
    return { hits, count };
  },

  // Combine partials IN THE GIVEN ORDER (fixed chunk-index order). Don't sort or rely on
  // arrival order — that's what keeps the result reproducible across machines.
  reduce(orderedPartials) {
    let hits = 0, count = 0;
    const samples = [];
    for (const p of orderedPartials) {
      hits += p.hits;
      count += p.count;
      samples.push(p.count > 0 ? (4 * p.hits) / p.count : 0);
    }
    return { result: count > 0 ? (4 * hits) / count : 0, samples };
  },
};
`;
